import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { resetTranslation } from 'src/features/translateArticle';

export const languageOptions = [
  {
    name: 'English',
    language: 'english'
  },
  {
    name: 'Tamil',
    language: 'tamil'
  },
  {
    name: 'Chinese',
    language: 'chinese'
  },
  {
    name: 'Indonesian',
    language: 'indonesian'
  },
  {
    name: 'Melayu',
    language: 'melayu'
  },
  {
    name: 'Korean',
    language: 'korean'
  }
];

export default function TranslatePopup({
  open,
  onClose,
  handleTranslate,
  isTranslated,
  loading
}: {
  open: boolean;
  onClose: () => void;
  handleTranslate: (language: string) => void;
  loading: boolean;
  isTranslated: boolean;
}) {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const { selectedTargetLanguage } = useAppSelector(
    (state) => state.storeTranslateArticle
  );
  const [selectedLanguageLocal, setSelectedLanguageLocal] = useState<string>(
    selectedTargetLanguage
  );

  const [openButtonTranslate, setOpenButtonTranslate] = useState<boolean>(true);

  useEffect(() => {
    if (selectedLanguageLocal === selectedTargetLanguage && isTranslated) {
      setOpenButtonTranslate(false);
    } else {
      setOpenButtonTranslate(true);
    }
  }, [selectedLanguageLocal, isTranslated]);

  return (
    <>
      <Dialog
        open={open}
        onClose={!loading ? onClose : undefined}
        scroll="paper"
        maxWidth="xs"
      >
        <DialogTitle
          sx={{
            p: theme.spacing(2, 2, 0, 2)
          }}
        >
          Translate Text
        </DialogTitle>
        <DialogContent sx={{ color: '#4B4B4B' }}>
          <Stack spacing={0.5}>
            <Typography>Translate to</Typography>
            <Select
              id="translateLanguages"
              name="translateLanguages"
              value={selectedLanguageLocal || undefined}
              onChange={(event) => setSelectedLanguageLocal(event.target.value)}
              placeholder="Select target language"
              fullWidth
              disabled={loading}
            >
              {languageOptions.map((item) => (
                <MenuItem
                  key={item.language}
                  id={item.language}
                  value={item.language}
                >
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </Stack>
        </DialogContent>
        <DialogActions>
          {openButtonTranslate ? (
            <Button
              variant="contained"
              onClick={() => {
                handleTranslate(selectedLanguageLocal);
              }}
              disabled={loading}
              sx={{ px: 4 }}
            >
              {loading ? 'Translating...' : 'Translate'}
            </Button>
          ) : (
            <Button
              variant="contained"
              onClick={onClose}
              disabled={loading}
              sx={{ px: 4 }}
            >
              Done
            </Button>
          )}
          {isTranslated && (
            <Button
              variant="outlined"
              onClick={() => {
                dispatch(resetTranslation());
                onClose();
              }}
              disabled={loading}
              sx={{ px: 4 }}
            >
              See Original
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}
